<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          responsive
          striped
          hover
          :fields="fields"
          :items="items"
          :busy="isBusy"
          show-empty
          empty-text="No matching records found"
        >
          <template #head(id)>
            <b-form-checkbox
              :id="'checkbox-staff-all'"
              :name="'checkbox-staff--all'"
              :value="true"
              :unchecked-value="false"
              @change="$emit('handleCheckAll', $event)"
            >
            </b-form-checkbox>
          </template>

          <template v-slot:cell(serial)="{ item }">
            {{ item.serial || "-" }}
          </template>
          <template v-slot:cell(log_type_name)="{ item }">
            {{ item.log_type_name || "-" }}
            <div v-if="item.log_type == 9">
              {{ item.inventory_from_name }} -> {{ item.inventory_to }}
            </div>
          </template>
          <template v-slot:cell(stock_type_name)="{ item }">
            {{ item.stock_type_name || "-" }}
          </template>

          <template v-slot:cell(name)="{ item }">
            <router-link :to="'/product/detail/' + item.product_id"
              ><u
                ><div>{{ item.name }}</div></u
              ></router-link
            >
            <div>{{ item.barcode }}</div>
          </template>
          <template v-slot:cell(note)="{ item }">
            <p>{{ item.note || "-" }}</p>
          </template>
          <template v-slot:cell(stock)="{ item }">
            <span>{{ item.stock | numeral("0,0") }}</span>
          </template>
          <template v-slot:cell(available)="{ item }">
            <span>{{ item.available | numeral("0,0") }}</span>
          </template>
          <template v-slot:cell(update_price)="{ item }">
            <span v-if="item.update_price">{{
              item.update_price | numeral("0,0.00")
            }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:cell(update_cost)="{ item }">
            <span v-if="item.update_cost">{{
              item.update_cost | numeral("0,0.00")
            }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:cell(invoice_no)="{ item }">
            <router-link
              v-if="item.invoice_no"
              :to="'/report/transaction/' + item.activity_ref_id"
              ><u
                ><div>{{ item.invoice_no }}</div></u
              ></router-link
            >
            <span v-else>-</span>
          </template>
          <template v-slot:cell(active)="{ item }">
            <span :class="item.active ? 'text-success' : 'text-error'">{{
              item.active ? "Active" : "Inactive"
            }}</span>
          </template>
          <template v-slot:cell(create_date)="{ item }">
            <div>{{ item.create_date | moment($formatDateNew) }}</div>
            <div class="text-secondary">
              {{ item.create_date | moment("(HH:mm:ss)") }}
            </div>
          </template>
          <template v-slot:cell(actions)="{ item }">
            <div class="d-flex justify-content-evenly">
              <router-link :to="'branch-management/inventory/' + item.id">
                <b-button variant="link" class="text-bg-primary px-1 py-0">
                  <font-awesome-icon icon="warehouse" title="Inventory" />
                </b-button>
              </router-link>
              <router-link :to="'branch-management/detail/' + item.id">
                <b-button variant="link" class="text-warning px-1 py-0">
                  <font-awesome-icon icon="pencil-alt" title="Edit" />
                </b-button>
              </router-link>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <Pagination
      @handleChangeTake="handleChangeTake"
      :pageOptions="pageOptions"
      :filter="filter"
      :rows="rows"
      @pagination="pagination"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination },
  props: {
    filter: {
      required: true,
      type: Object,
    },
    pageOptions: {
      required: false,
      type: Array,
    },
    fields: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    rows: {
      required: true,
      type: Number,
    },
    showingTo: {
      required: true,
      type: Number,
    },
  },
  methods: {
    toggleCheckAll(val) {
      this.items.map((el) => (el.isCheck = val));
    },
    stringName(item) {
      const first_name = item.first_name || "";
      const last_name = item.last_name || "";

      return first_name + " " + last_name;
    },
    handleChangeTake(value) {
      this.filter.page = 1;

      this.filter.take = value;
      this.$emit("filterPage", this.filter);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
    },
    chkBirthday(birthday) {
      let birthDate = birthday.search("00:00:00");
      if (birthDate === -1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: var(--theme-secondary-color);
  color: var(--font-color);
}
.color-red {
  color: #dc3545;
}
.color-green {
  color: #28a745;
}
.color-blue {
  color: lightcoral;
}
</style>
